import { ErrorView } from "components/ErrorView/ErrorView";
import ModuleRoute from "components/ModuleRoute/ModuleRoute";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { RouteObject } from "react-router-dom";

const UserDetailsPage = React.lazy(() => import("./pages/UserDetailsPage/UserDetailsPage"));
const OnboardingModule = React.lazy(() => import("./OnboardingModule"));
const UserResearchInterpretationPage = React.lazy(
  () => import("./pages/UserResearchInterpretationConfidencePage/UserResearchInterpretationConfidencePage"),
);
const UserResearchSetupPage = React.lazy(
  () => import("./pages/UserResearchSetupConfidencePage/UserResearchSetupConfidencePage"),
);
const UserRolePage = React.lazy(() => import("./pages/UserRolePage/UserRolePage"));

const OnboardingLandingPage = React.lazy(() => import("./pages/OnboardingLandingPage/OnboardingLandingPage"));

export const OnboardingModuleRoutes: RouteObject = {
  path: "onboarding/",
  element: <ModuleRoute El={OnboardingModule} moduleName="onboarding" />,
  errorElement: <ErrorView />,
  children: [
    {
      path: "user-details",
      element: <PageRoute El={UserDetailsPage} />,
    },
    {
      path: "check-in",
      element: <PageRoute El={OnboardingLandingPage} />,
    },
    {
      path: "role",
      element: <PageRoute El={UserRolePage} />,
    },
    {
      path: "setup-confidence",
      element: <PageRoute El={UserResearchSetupPage} />,
    },
    {
      path: "interpretation-confidence",
      element: <PageRoute El={UserResearchInterpretationPage} />,
    },
  ],
};
export default OnboardingModuleRoutes;
